module.exports = __webpack_public_path__ + "img/adv4.5e244642.png";